export const onlyMobile = '@media (max-width: 768px)';
export const onlyDesktop = '@media (min-width: 769px)';
export const hideMobile = {
  hideMobile: {
    [onlyMobile]: {
      display: 'none',
    },
  },
};
export const hideDesktop = {
  hideDesktop: {
    [onlyDesktop]: {
      display: 'none',
    },
  },
};
